import nfetch from "../utils/events/nfetch";

export default class AzulCargoService {
    public gerarMinuta(obj: object): Promise<Response> {
        return nfetch("/AzulCargo/GerarMinuta", {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(obj),
        });
    }
}
